import { statusIds, statusesTranslate } from '../../../utils/constants/orders_statuses';
import { type SupportOrder } from '../../../redux/types/SupportTypes';

export const statusLabel = (code: string): string => {
  const index = statusIds.indexOf(code);
  return index >= 0 ? statusesTranslate[index] : code;
};

export const statusTone = (code: string): 'ok' | 'warn' | 'bad' | 'muted' => {
  if (['SF', 'AA', 'AAD', 'FR'].includes(code)) return 'ok';
  if (['ID', 'UR', 'BN', 'IP'].includes(code)) return 'warn';
  if (['TO', 'CANCELED', 'CR', 'NF'].includes(code)) return 'bad';
  return 'muted';
};

// Statuses offered in the filter; the backend accepts any code, these are the ones support looks for
export const STATUS_OPTIONS: Array<{ id: string; name: string }> = [
  { id: '', name: 'Все (кроме «реквизит не найден»)' },
  { id: 'ID', name: 'Спор' },
  { id: 'SF,AA,AAD,FR', name: 'Успешные' },
  { id: 'TO,CANCELED,CR', name: 'Неуспешные' },
  { id: 'BN,IP,UR', name: 'В работе' },
  { id: 'NF', name: 'Реквизит не найден' },
];

export const formatMoney = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  return number.toLocaleString('ru-RU', { maximumFractionDigits: 2 });
};

const positive = (value: string | null | undefined): string | null => (value && Number(value) > 0 ? value : null);

// In dispute the disputed amount (temp_income) is shown; otherwise the settled amount, falling back to the requested one
export const orderAmount = (order: SupportOrder): string =>
  (order.status === 'ID' ? positive(order.temp_income) : positive(order.real_income)) || order.expected_income;

export const requisiteLabel = (order: SupportOrder): string => {
  const req = order.requisite;
  if (!req) return '—';
  const number = req.account_number || req.phone_number || '';
  const bank = req.bank ? ` · ${req.bank}` : '';
  return `${number}${bank}`.trim() || '—';
};

export const shortId = (id: string): string => `${id.slice(0, 8)}…`;

// Error text from a DRF response: {"error": "..."} or {"field": ["..."]} or a plain string
export const errorText = (error: unknown, fallback: string): string => {
  const data = (error as { data?: unknown })?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data === 'object') {
    const first = Object.entries(data as Record<string, unknown>)[0];
    if (!first) return fallback;
    const [key, value] = first;
    const text = Array.isArray(value) ? value.join(', ') : String(value);
    return key === 'error' || key === 'detail' ? text : `${key}: ${text}`;
  }
  return fallback;
};
